import React, {useState, useEffect} from 'react';

const InputStart = ({index, elem, handleStarClick, validateForm, validateInput, _getStarsValid}) => {

    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        if(validateForm){
            validateForm();
        } 
    },[isValid])

    const _onChange = (event) => {
        const validate = validateInput ? validateInput(event.target.value) : isValid;
        setIsValid(validate)
        _getStarsValid(validate, event.target.value)
        validateForm();
    }

    const _onBlur = (event) => {
        const valid = validateInput(event.target.value);
        setIsValid(valid)
        _getStarsValid(valid, event.target.value);
        validateForm();
    }

    return (
        <>
            <input
                type="radio"
                value={index}
                className={'drawer-stars-btn'}
                id={'radio' + index}
                onClick={(e) => handleStarClick(e, index)}
                onChange={_onChange}
                onBlur={_onBlur}
            />
            {elem}
        </>
    )
}

export default InputStart;